import { render, staticRenderFns } from "./member_reward_supdeduct_detail.vue?vue&type=template&id=2ac79070&scoped=true"
import script from "./member_reward_supdeduct_detail.vue?vue&type=script&lang=js"
export * from "./member_reward_supdeduct_detail.vue?vue&type=script&lang=js"
import style0 from "./member_reward_supdeduct_detail.vue?vue&type=style&index=0&id=2ac79070&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac79070",
  null
  
)

export default component.exports